"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _LoadingDots = _interopRequireDefault(require("../../animations/LoadingDots/LoadingDots"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple component for displaying a button
 * @param {Object} children React children prop for wrapped content
 */
const getClassName = props => {
  let cssClass = props.primary ? `rui-button rui-button--primary` : `rui-button rui-button--secondary`;
  return props.className ? `${cssClass} ${props.className}` : cssClass;
};

const StyledButton = ({
  children,
  type,
  submitting,
  overlay,
  disabled,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Button, {
    type: type,
    className: getClassName(otherProps),
    disabled: disabled || submitting,
    submitting: submitting,
    ...otherProps,
    children: [submitting && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingDots.default, {
      color: "currentColor"
    }), !submitting && children]
  }), submitting && overlay && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubmittingOverlay, {})]
});

StyledButton.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,
  type: _propTypes.default.oneOf(['button', 'submit']),
  primary: _propTypes.default.bool,
  small: _propTypes.default.bool,
  sm: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  submitting: _propTypes.default.bool,
  overlay: _propTypes.default.bool,
  neutral: _propTypes.default.bool
};
StyledButton.defaultProps = {
  type: 'button',
  primary: undefined,
  small: undefined,
  sm: undefined,
  disabled: false,
  submitting: false,
  overlay: true,
  neutral: false
};
StyledButton.displayName = 'Button';
var _default = StyledButton;
exports.default = _default;